<script setup>
const props=defineProps(['tabsList','bottom','left'])
const emits=defineEmits(['setCheckTabs'])
const activeId = ref(1);
const changeTab = (id, event) => {
    console.log(id)
    // 如果选择的和当前激活的不同
    if (id !== activeId.value) {
    activeId.value = id;
    emits('setCheckTabs',activeId.value)
    // 计算当前按钮的位置，看是否需要移动
    const spanLeft = event.clientX; // 当前点击的元素左边距离
    const divBox = document.querySelector(".select-tab").clientWidth / 2; // 点击的元素一半宽度
    const totalWidths = document.body.clientWidth; // 屏幕总宽度
    const widths = totalWidths / 2; // 一半的屏幕宽度
    const spanRight = totalWidths - spanLeft; // 元素的右边距离
    const scrollBox = document.querySelector(".fixed-nav"); // 获取最外层的元素
    const scrollL = scrollBox.scrollLeft; // 滚动条滚动的距离
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 100 || spanLeft < 100) {
            scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
        }
    }
}
</script>
<template>
    <div class="tabs">
        <section class="theme-list" v-if="!left">
            <div :class="['fixed-nav',props.bottom==true ? 'fixed-nav-Bottom':'']" ref="fixednav">
                <div class="fixed-nav-content">
                    <p v-for="(item, index) in props.tabsList" :key="index"
                        :class="['tab-title', activeId === item.id && 'select-tab']"
                        @click="changeTab(item.id, $event)">
                        {{ item.name }}
                    </p>
                </div>
            </div>
        </section>
        <section class="theme-list left" v-else>
            <div :class="['fixed-nav',props.bottom==true ? 'fixed-nav-Bottom':'']" ref="fixednav">
                <div class="fixed-nav-content">
                    <p v-for="(item, index) in props.tabsList" :key="index"
                        :class="['tab-title', activeId === item.id && 'select-tab']"
                        @click="changeTab(item.id, $event)">
                        {{ item.name }}
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>
<style scoped lang="scss">
.tabs{
    padding-bottom: 20px;
    .theme-list {
        //   margin-top: 12px;
    }
    .fixed-nav-Bottom{
        border-bottom: 1px solid #eee;
    }
    .fixed-nav {
        // padding-top: 20px;
        // border-bottom: 1px solid #eee;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
    }
    .fixed-nav-content {
        display: flex;
    }
    .tab-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #888888;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        margin:0 20px;
        // margin-right:20px;
        flex-shrink: 0;
        height: 30px;
        position: relative; /* 相对定位 */
    }

.select-tab {
 
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #11192D;
    line-height: 18px;
    text-align: left;
    font-style: normal;
}

.tab-title.select-tab::after {
  content: '';
  position: absolute;
  left: calc(50% - 10px); /* 动态计算 left 的值，使其居中 */
  right: auto; /* 禁用 right 的值 */
  bottom: -2px;
  width: 20px;
  height: 4px;
  background: #FC3938;
  border-radius: 2px;
  transition: background-color 0.3s; /* 背景色过渡效果 */
}
}
@media (max-width: 768px) {
    .tabs{
        padding-bottom: 4px;
        .theme-list {
            //   margin-top: 12px;
        }
       
        .fixed-nav-Bottom{
            border-bottom: 1px solid #eee;
        }
        .fixed-nav {
            // padding-top: 20px;
            // border-bottom: 1px solid #eee;
            overflow-x: scroll;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
        }
        .fixed-nav-content {
            display: flex;
        }
        .tab-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #888888;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            margin:0 20px;
            flex-shrink: 0;
            height: 30px;
            position: relative; /* 相对定位 */
        }

    .select-tab {
    
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #11192D;
        line-height: 18px;
        text-align: left;
        font-style: normal;
    }

    .tab-title.select-tab::after {
        content: '';
        position: absolute;
        left: calc(50% - 10px); /* 动态计算 left 的值，使其居中 */
        right: auto; /* 禁用 right 的值 */
        bottom: -2px;
        width: 12px;
        height: 4px;
        background: #FC3938;
        border-radius: 2px;
        transition: background-color 0.3s; /* 背景色过渡效果 */
        }
    } 
    .left{
         .tab-title{
            margin: 0;
            margin-right: 20px;
            width: auto;
         }
        
        }
}
</style>